import { observer } from "mobx-react-lite";
import { FC } from "react";
import styled from "@emotion/styled";
import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds";

interface AppCalloutBannerPrimaryLabelProps {
  label: string;
}

export const AppCalloutBannerPrimaryLabel: FC<AppCalloutBannerPrimaryLabelProps> = observer(
  ({ label }) => {
    if (!label) return null;

    return (
      <PrimaryLabelText variant={MDSTextVariant.TextM} weight={MDSTextWeight.SemiBold}>
        {label}
      </PrimaryLabelText>
    );
  }
);

const PrimaryLabelText = styled(MDSText)({
  marginBottom: "4px",
});
